import type { PlatformPermission } from "@/hooks/useMyPlatformPermissions";

export type AdminWorkspace =
  | "tenants"
  | "users"
  | "roles"
  | "settings"
  | "billing"
  | "health";

const workspacePermissions: Record<AdminWorkspace, readonly PlatformPermission[]> = {
  tenants: ["tenant_manager", "view_tenant_dashboard", "view_tenant_health_detail"],
  users: ["tenant_manager", "view_tenant_dashboard"],
  roles: ["tenant_manager"],
  settings: ["feature_manager"],
  billing: [
    "view_billing_summary",
    "billing_access",
    "manage_billing",
    "manage_invoices",
    "manage_memberships",
  ],
  health: [
    "view_performance_centre",
    "view_tenant_dashboard",
    "view_tenant_health_detail",
    "manage_background_jobs",
  ],
};

export function canAccessAdminWorkspace(
  workspace: AdminWorkspace,
  permissions: readonly PlatformPermission[],
): boolean {
  return workspacePermissions[workspace].some((permission) => permissions.includes(permission));
}